import React, { Component } from 'react';
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';
import IconComponent from '../iconComponent';

export default class ErrorDialog extends Component {

    render() {

        const customContentStyle = {
            width: '475px',
            backgroundColor: '#D82D49'
        };

        const { deleteButtonText } = this.props;        

        const actions = [
            <Button 
                buttonType={ButtonType.red}
                onClick={this.props.onConfirm}
                text={deleteButtonText}
            >
            </Button>
        ];

        const title = <DialogHeader 
                        title={this.props.titleText}
                        closeClick={this.props.closeDeleteDialog}
                        displayCloseButton
                    />;

        return (
            <Dialog
                title={title}
                className='portal-confirm-dialog'
                titleClassName='portal-confirm-dialog-header alert-confirm'
                bodyClassName='portal-confirm-dialog-body'
                actionsContainerClassName='portal-confirm-dialog-actions'
                actions={actions}
                modal={true}
                contentStyle={customContentStyle}
                open={this.props.show}
            >
                <div
                    data-cy={this.props.dataCy}
                >
                    {this.props.contentText}
                </div>
            </Dialog>
        );
    }    
}


// WEBPACK FOOTER //
// ./src/components/portal/dialogs/errorDialog.jsx